/**
 * The .NET API sets a readable `XSRF-TOKEN` cookie alongside the httpOnly
 * antiforgery cookie. We read it from `document.cookie` and echo it back
 * on every mutating request as `X-XSRF-TOKEN`. The httpOnly companion
 * cookie travels automatically.
 *
 * The login endpoint is `[IgnoreAntiforgeryToken]` so the very first
 * POST does not need the header. /auth/me re-issues the cookie pair
 * on every authenticated read.
 */

export function readXsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith('XSRF-TOKEN='));
  if (!match) return null;
  const raw = match.slice('XSRF-TOKEN='.length);
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
